export const homeTranslations = {
  es: {
    home: {
      subtitle: "IA en salud",
      title: "Habilitamos la [[Adopción]] de IA para Apoyo Diagnóstico",
      description:
        "Construimos junto a cada institución el camino para adoptar IA en apoyo diagnóstico, con seguridad, interoperabilidad y libertad para evolucionar con distintas soluciones.",
      stats: {
        title: "Escaneo de Precisión",
        description: "Validación clínica de 4 anomalías en curso.",
      },
    },
  },
  en: {
    home: {
      subtitle: "AI in healthcare",
      title: "Enabling AI [[Adoption]] in Diagnostic Support",
      description:
        "We build with each institution the path to adopt AI in diagnostic support, with security, interoperability and freedom to evolve with different solutions.",
      stats: {
        title: "Precision Scanning",
        description: "Clinical validation of 4 ongoing anomalies.",
      },
    },
  },
};
